const language = document.getElementsByTagName('html')[0].attributes.lang.value;
const maximumPassengers = document.getElementById('maximum-passengers').dataset.maximumPassengers;

const translations= {
    en: {
        TODAY_STRING: 'Today',
        PLEASE_CHOOSE: 'Please choose',
        WEEKDAYS: ["MO", "TU", "WE", "TH", "FR", "SA", "SU"],
        LEGENDS: {
            today: 'Today',
            fullClosed: 'Full / Closed',
            available: 'Available',
            offSeason: 'Off season'
        },
        PASSENGERS: {
            modalTitle: 'Number of passengers',
            modalText: `In order to provide you with our flight availability based on the number of passengers, please let us know the number of passengers who will be participating in this flight.`,
            save: 'Save',
            alert: {
                heading: 'Nombre incorrect',
                content: `The number of passengers must be between 1 and ` + maximumPassengers + `.`,
                complement: `If you wish to reserve more than ` + maximumPassengers + ` seats, you can create several reservations.`
            }
        },
        SLOTS: {
            flightType: {
                mountainFlight: 'Morning Flight',
                mountainFlightDescription: 'mountain',
                lowlandFlight: 'Evening Flight',
                lowlandFlightDescription: 'Swiss plateau'
            },
            book: 'Book',
            remainingPlaces: 'places',
            remainingPlace: 'place'
        },
        DISCOUNT_VOUCHER: {
            label: 'Discount voucher',
            placeholder: 'Voucher no.',
            remainingAmount: `The remaining amount on your voucher will be %s.`
        },
        ORDER_SUMMARY: {
            title: 'Your order summary',
            alert: `Please select a flight from the calendar.`,
            adultFlight: `Adult passenger flight`,
            childFlight: `Child passenger flight`,
            promoCodeDiscount: 'Promo code discount'
        },
        PROMO_CODE: {
            label: 'Promo code',
            placeholder: 'PROMO CODE',
            verifying: 'Checking…',
            applied: 'Promo applied.',
            invalid: 'This promo code is not valid.',
            networkError: 'Unable to verify the code. Please try again.',
            fapdeNeedChild: 'This promo code requires at least one child passenger.',
            fapdeNeedAdult: 'This promo code requires at least one adult passenger.',
            inactive: 'This promo code exists but is not activated yet.'
        }
    },

    fr: {
        TODAY_STRING: "Aujourd'hui",
        PLEASE_CHOOSE: "Veuillez choisir",
        WEEKDAYS: ["LU", "MA", "ME", "JE", "VE", "SA", "DI"],
        LEGENDS: {
            today: `Aujourd'hui`,
            fullClosed: 'Complet / Fermé',
            available: 'Disponible',
            offSeason: 'Hors saison'
        },
        PASSENGERS: {
            modalTitle: 'Nombre de passagers',
            modalText: `Afin de vous fournir les disponibilités de nos vols en fonction du nombre de passagers, veuillez nous indiquer le nombre de passagers qui participeront à ce vol.`,
            save: 'Enregistrer',
            alert: {
                heading: 'Nombre incorrect',
                content: `Le nombre de passagers doit être compris entre 1 et ` + maximumPassengers + `.`,
                complement: `Si vous souhaitez réserver plus de ` + maximumPassengers + ` places, vous pouvez créer plusieurs réservations.`
            }
        },
        SLOTS: {
            flightType: {
                mountainFlight: 'Vol du Matin',
                mountainFlightDescription: 'montagne',
                lowlandFlight: 'Vol du Soir',
                lowlandFlightDescription: 'plateau suisse'
            },
            book: 'Réserver',
            remainingPlaces: 'places',
            remainingPlace: 'place'
        },
        DISCOUNT_VOUCHER: {
            label: 'Bon de réduction',
            placeholder: 'N° de bon',
            remainingAmount: `Le montant restant sur votre bon sera de %s.`
        },
        ORDER_SUMMARY: {
            title: 'Résumé de votre commande',
            alert: `Veuillez sélectionner un vol à partir du calendrier.`,
            adultFlight: `Vol passager adulte`,
            childFlight: `Vol passager enfant`,
            promoCodeDiscount: 'Remise code promo'
        },
        PROMO_CODE: {
            label: 'Code promo',
            placeholder: 'CODE PROMO',
            verifying: 'Vérification…',
            applied: 'Code promo appliqué.',
            invalid: 'Ce code promo n’est pas valable.',
            networkError: 'Impossible de vérifier le code. Réessayez.',
            fapdeNeedChild: 'Ce code promo nécessite au moins un passager enfant.',
            fapdeNeedAdult: 'Ce code promo nécessite au moins un passager adulte.',
            inactive: 'Ce code promo existe mais n’est pas encore activé.'
        }
    },

    de: {
        TODAY_STRING: 'Heute',
        WEEKDAYS: ["MO", "DI", "MI", "DO", "FR", "SA", "SO"],
        LEGENDS: {
            today: 'Heute',
            fullClosed: 'Voll / Geschlossen',
            available: 'Verfügbar',
            offSeason: 'Nebensaison'
        },
        PASSENGERS: {
            modalTitle: 'Anzahl der Passagiere',
            modalText: `Um Ihnen unsere Flugverfügbarkeit basierend auf der Anzahl der Passagiere anbieten zu können, teilen Sie uns bitte die Anzahl der Passagiere mit, die an diesem Flug teilnehmen werden.`,
            save: 'Speichern',
            alert: {
                heading: 'Nombre incorrect',
                content: `Die Anzahl der Passagiere muss zwischen 1 und ` + maximumPassengers + ` liegen.`,
                complement: `Wenn Sie mehr als ` + maximumPassengers + ` Plätze reservieren möchten, können Sie mehrere Reservierungen erstellen.`
            }
        },
        SLOTS: {
            flightType: {
                mountainFlight: 'Morgenflug',
                mountainFlightDescription: 'Berge',
                lowlandFlight: 'Abendlicher Flug',
                lowlandFlightDescription: 'Mittelland'
            },
            book: 'Reservieren',
            remainingPlaces: 'Plätze',
            remainingPlace: 'Platz'
        },
        DISCOUNT_VOUCHER: {
            label: 'Discount Voucher',
            placeholder: 'Gutschein Nr.',
            remainingAmount: `Der Restbetrag auf Ihrem Gutschein wird %s betragen.`
        },
        ORDER_SUMMARY: {
            title: 'Ihre Bestellübersicht',
            alert: `Bitte wählen Sie einen Flug aus dem Kalender aus.`,
            adultFlight: `Erwachsener Passagierflug`,
            childFlight: `Kind Passagierflug`,
            promoCodeDiscount: 'Rabatt Aktionscode'
        },
        PROMO_CODE: {
            label: 'Aktionscode',
            placeholder: 'AKTIONSCODE',
            verifying: 'Wird geprüft…',
            applied: 'Aktionscode angewendet.',
            invalid: 'Dieser Aktionscode ist ungültig.',
            networkError: 'Der Code konnte nicht geprüft werden. Bitte erneut versuchen.',
            fapdeNeedChild: 'Dieser Aktionscode erfordert mindestens einen Kind-Passagier.',
            fapdeNeedAdult: 'Dieser Aktionscode erfordert mindestens einen Erwachsenen-Passagier.',
            inactive: 'Dieser Aktionscode existiert, ist aber noch nicht aktiviert.'
        }
    }
}

module.exports = translations[language];
